import React from "react";

export default class TermsOfService extends React.Component {
    render() {
        return (
            <div className="min-h-screen bg-[#f8fafc] text-[#0f172a] px-6 py-10 md:px-20">
                <div className="max-w-4xl mx-auto">
                    <div className="hk-eyebrow">Legal</div>
                    <h1 className="hk-display text-4xl font-bold mb-3">Terms of Service</h1>
                    <p className="text-sm text-gray-500 mb-10">
                        Last updated: October 20, 2026
                    </p>

                    <section className="mb-8">
                        <h2 className="text-xl font-semibold mb-2">1. Acceptance of Terms</h2>
                        <p>
                            By accessing or using Haki services, you agree to be bound by these Terms of Service.
                            If you do not agree, you must not use our services.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-xl font-semibold mb-2">2. Description of Service</h2>
                        <p>
                            Haki provides software tools and automation services, including chatbot systems,
                            integrations, and deployment infrastructure for business operations.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-xl font-semibold mb-2">3. User Responsibilities</h2>
                        <p>
                            You agree to use the service lawfully and not engage in misuse, abuse, unauthorized access,
                            or disruption of systems. You are responsible for maintaining the confidentiality of your credentials.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-xl font-semibold mb-2">4. Accounts and Access</h2>
                        <p>
                            You are responsible for all activities under your account. We reserve the right to suspend
                            or terminate access if suspicious or harmful activity is detected.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-xl font-semibold mb-2">5. Payments and Billing</h2>
                        <p>
                            Some services may require payment. Prices and applicable charges will be presented before payment is completed.
                            <br />Payments are generally non-refundable unless otherwise stated in these Terms, required by applicable law, or approved by Haki.
                            <br />
                            <br />Where a refund is permitted or required, the refund amount may be reduced by applicable payment-processing fees or other transaction charges that are non-refundable to Haki, to the extent permitted by applicable law and the payment provider's policies. Any such deduction will be disclosed where applicable.
                            <br />Refunds will not exceed the amount paid for the relevant transaction, except where otherwise required by law. Fees that are refundable or recoverable by Haki will not be deducted from the refund.
                            <br />
                            <br />We reserve the right to modify pricing with reasonable notice. Price changes will not retroactively alter completed transactions.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-xl font-semibold mb-2">6. Service Availability</h2>
                        <p>
                            We do not guarantee uninterrupted service. Maintenance, outages, or third-party failures
                            may affect availability.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-xl font-semibold mb-2">7. Intellectual Property</h2>
                        <p>
                            All content, branding, and software associated with Haki are owned by Haki or its licensors.
                            You may not copy, modify, or distribute without permission.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-xl font-semibold mb-2">8. Limitation of Liability</h2>
                        <p>
                            Haki is not liable for any indirect, incidental, or consequential damages resulting from
                            the use or inability to use the service.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-xl font-semibold mb-2">9. Termination</h2>
                        <p>
                            We may suspend or terminate access at any time if you violate these terms or engage in harmful activity.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-xl font-semibold mb-2">10. Changes to Terms</h2>
                        <p>
                            We may update these Terms of Service periodically. Continued use of the service constitutes acceptance
                            of the revised terms.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-xl font-semibold mb-2">11. Contact</h2>
                        <p>
                            If you have questions regarding these Terms, contact us at support@nekobiz.com.
                        </p>
                    </section>

                    <footer className="mt-12 text-sm text-gray-500">
                        Haki © {new Date().getFullYear()} Nekobiz. All rights reserved.
                    </footer>
                </div>
            </div>
        );
    }
}
